// App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar";
import Detail from "./components/Detail";
import Home from "./components/Home";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Statistics from "./components/Statistics";

function App() {
  const [data, setData] = useState([]);
  const [stationsData, setStationsData] = useState([]);

  useEffect(() => {
    fetch("https://test.visiontronic.cz/dayAggregatedAPI.php")
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);

  useEffect(() => {
    fetch("https://test.visiontronic.cz/stations.php")
      .then((response) => response.json())
      .then((data) => setStationsData(data));
  }, []);

  //const userIdMachine = user["https://YOUR_NAMESPACE/coin_access"].IdMachine;
  //console.log(userIdMachine);

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <NavBar />
          <Routes>
            <Route
              path="/"
              element={<Home data={data} stationsData={stationsData} />}
            />
            <Route path="/detail/:IdMachine" element={<Detail />} />
            <Route path="/statistiky" element={<Statistics />} />
          </Routes>
        </header>
      </div>
    </Router>
  );
}

export default withAuthenticationRequired(App, {
  onRedirecting: () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        color: "white",
      }}
    >
      Načítám data...
    </div>
  ),
});
